import { connect, MapStateToProps } from 'react-redux';
import { getIsMobile } from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { AppState } from '../../../../types/store';
import { selectors } from '@wix/da-shared-react/pkg/CommentThread';
import { CommentableTypes } from '@wix/da-shared-react/pkg/Comment/types';
import { Props } from './ProfileCommentsBox';

type StateProps = Pick<
  Props,
  'profileOwnerUser' | 'isOwner' | 'isMobile' | 'totalCount'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const profileOwnerUser = getProfileOwnerUser(state);
  return {
    profileOwnerUser,
    isOwner: isCurrentUserProfileOwner(state),
    isMobile: getIsMobile(state),
    totalCount: selectors.getTotal(
      state,
      CommentableTypes.COMMENT_USER,
      profileOwnerUser.userId
    ),
  };
};

export default connect(mapStateToProps);
